import { useState, useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import { FormLayout, TextField, Form } from "@shopify/polaris";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { fetchFileCategoryById } from "services/files-category.service";
import { AppDispatch } from "configureStore";
import MultipleUserSelect from "features/multi-user-select/multi-user-select";

interface FilesCategoryProps {
  onSubmit?: (result: any) => void;
  id?: string;
  parentId?: string | null;
}

const InfoFilesCategory: React.FC<FilesCategoryProps> = ({
  onSubmit,
  id,
  parentId,
}) => {
  const dispatch: AppDispatch = useDispatch();
  const { t } = useTranslation();
  const { companyId } = useParams<{ companyId: string }>();
  const [requiredWithinDays, setRequiredWithDays] = useState<string>("");
  const [errMsg, setErrMsg] = useState<string | undefined>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [responsibleUser, setResponsibleUser] = useState<any>([]);

  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  const fetchData = useCallback(
    async (id: string) => {
      setIsLoading(true);
      const data = await fetchFileCategoryById(companyId, id);
      setRequiredWithDays(data.requiredWithinDays);
      setResponsibleUser(data.responsibleUser || []);
      setIsLoading(true);
    },
    [companyId]
  );

  useEffect(() => {
    if (id) {
      fetchData(id);
    }
  }, [id, fetchData]);

  return (
    <Form onSubmit={() => ""}>
      <FormLayout>
        <TextField
          label={t("required_within_days")}
          id="required_within_days"
          name="required_within_days"
          value={requiredWithinDays}
          onChange={(value) => setRequiredWithDays(value)}
          error={errors.requiredWithinDays}
          autoComplete="off"
          readOnly={true}
        />

        <MultipleUserSelect
          onChange={setResponsibleUser}
          value={responsibleUser}
          label={t("responsible_user")}
          isUserGuest={false}
          readOnly={true}
        />
      </FormLayout>
    </Form>
  );
};

export default InfoFilesCategory;
